export default {
  title: 'Usuários',
  UsersView: {
    deleteTitle: 'Lista de usuários para excluir',
    success: 'Os usuários foram excluídos com sucesso.'
  },
  user: {
    new: 'Novo usuário',
    data: 'Introduza os dados do novo usuário',
    add: 'Adicionar usuário',
    changePass: 'Modificar senha'
  },
  table: {
    saveNew: 'Guardar como novo elemento',
    createAndSelect: 'Criar e selecionar',
    updateAndSelect: 'Atualizar e selecionar',
    undo: 'Desfazer alterações',
    select: 'Selecionar',
    noResults: 'Nenhum resultado encontrado',
    username: 'Usuário',
    userRole: 'Papel',
    email: 'email',
    enabled: 'Habilitado',
    disabled: 'Desabilitado'
  },
  searchUser: {
    title: 'Agenda',
    search: 'Buscar em usuários',
    showing: 'Mostrando',
    username: 'Usuário',
    userRole: 'Papel',
    email: 'Email',
    more: 'Ver mais',
    addSelected: 'Adicionar selecionado',
    allContacts: 'Todos os contatos',
    deleteTitle: 'Excluir usuários selecionados',
    deleteConfirm: 'Tem certeza de que deseja excluir os usuários selecionados?'
  },
  button: {
    newElement: 'Novo Usuário'
  },
  roles: {
    ROLE_ADMIN: 'Admin',
    ROLE_BASIC: 'Básico'
  }
}